/**
 * Logger utility for development vs production environments
 * All console statements are disabled in production
 */

const isDev = process.env.NODE_ENV === 'development';

const logger = {
  log: (...args) => {
    if (isDev) console.log(...args);
  },
  warn: (...args) => {
    if (isDev) console.warn(...args);
  },
  error: (...args) => {
    // Errors are always logged but could be sent to a service in production
    if (isDev) {
      console.error(...args);
    }
    // In production, you could send to error tracking service like Sentry
  },
  debug: (...args) => {
    if (isDev) console.debug(...args);
  },
  info: (...args) => {
    if (isDev) console.info(...args);
  }
};

export default logger;
